export const GET_CONTENT = 'GET_CONTENT';
export const ADD_CONTENT = 'ADD_CONTENT';
export const UPDATE_CONTENT = 'UPDATE_CONTENT';
export const DELETE_CONTENT = 'DELETE_CONTENT';
export const SELECT_TAG = 'SELECT_TAG';
export const TOGGLE_SORTING_ORDER = 'TOGGLE_SORTING_ORDER';
export const ADD_TO_READING_HISTORY = 'ADD_TO_READING_HISTORY';